import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';

import { _nextTrackEvent } from '../index';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const EVENT_IDS = {
  LEARN_MORE: '8213',
  REGULATIONS_CTA: '8214',
  TOTAL_PRICE_TOGGLE_OFF_TO_ON: '8222',
  TOTAL_PRICE_TOGGLE_ON_TO_OFF: '8223',
  CLOSE_TOTAL_PRICE_MODAL: '8357',
} as const;

type MFTmpEventProps = {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
};

type MFTmpEventWithTriggerProps = MFTmpEventProps & {
  triggerObject?: string;
};

// https://dataportal.zillowgroup.net/event-registry/8213
export const emitLearnMoreEvent = ({ currentProperty, user, triggerObject }: MFTmpEventWithTriggerProps) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.LEARN_MORE,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_posting_path',
      trigger_source_nm: 'learn_more_cta',
      trigger_object_nm: triggerObject || '',
    },
    semantic: {
      semantic_event_nm: 'open_partner_blog',
      topic_tag_txt: ['costs_and_fees'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8214
export const emitRegulationsCTAEvent = ({ currentProperty, user }: MFTmpEventProps) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.REGULATIONS_CTA,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_posting_path',
      trigger_source_nm: 'fee_transparency_laws_cta',
      trigger_object_nm: 'feature_promotion_toggle_geo',
    },
    semantic: {
      semantic_event_nm: 'open_regulations',
      topic_tag_txt: ['costs_and_fees'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8222
export const emitTotalPriceToggleOffToOnEvent = ({
  currentProperty,
  user,
  triggerObject,
}: MFTmpEventWithTriggerProps) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.TOTAL_PRICE_TOGGLE_OFF_TO_ON,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_posting_path',
      trigger_source_nm: 'total_price_toggle',
      trigger_object_nm: triggerObject || '',
    },
    semantic: {
      semantic_event_nm: 'toggle_total_price',
      topic_tag_txt: ['costs_and_fees'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8223
export const emitTotalPriceToggleOnToOffEvent = ({
  currentProperty,
  user,
  triggerObject,
}: MFTmpEventWithTriggerProps) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.TOTAL_PRICE_TOGGLE_ON_TO_OFF,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_posting_path',
      trigger_source_nm: 'total_price_toggle',
      trigger_object_nm: triggerObject || '',
    },
    semantic: {
      semantic_event_nm: 'toggle_total_price',
      topic_tag_txt: ['costs_and_fees'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8357
export const emitCloseTotalPriceModalEvent = ({
  currentProperty,
  user,
  triggerSource,
}: MFTmpEventProps & { triggerSource: string }) =>
  _nextTrackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.CLOSE_TOTAL_PRICE_MODAL,
      event_type_version_id: '3',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'zram_posting_path',
      trigger_source_nm: triggerSource,
      trigger_object_nm: 'zram_costs_and_fees_tmp_modal',
    },
    semantic: {
      semantic_event_nm: 'close_total_price_modal',
      topic_tag_txt: ['costs_and_fees'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });
